import { render, staticRenderFns } from "./BackgroundItem.vue?vue&type=template&id=0c5c0772&scoped=true&"
import script from "./BackgroundItem.vue?vue&type=script&lang=js&"
export * from "./BackgroundItem.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundItem.vue?vue&type=style&index=0&id=0c5c0772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c0772",
  null
  
)

export default component.exports